import React from "react";
import Showcase from "./Showcase";
import "./App.css";

const App = () => (
  <div className="App App--showcase">
    <Showcase />
  </div>
);

export default App;
